export const isValidDate = (date: any): date is string => typeof date === 'string' && !Number.isNaN(Date.parse(date))
